import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useAuth } from '@/contexts/AuthContext';
import { resolveAuthGuardDecision } from '@/utils/authGuard';

export default function AuthGuard({ children }) {
    const router = useRouter();
    const { user, loading, accessLevel, accessLoading } = useAuth();
    const [authorized, setAuthorized] = useState(false);

    useEffect(() => {
        const decision = resolveAuthGuardDecision({
            user,
            loading,
            accessLevel,
            accessLoading,
            path: router.pathname,
            asPath: router.asPath,
            redirectToQuery: router.query?.redirectTo,
        });

        setAuthorized(decision.authorized);

        if (decision.redirect) {
            router.replace(decision.redirect);
            return;
        }
    }, [
        user,
        loading,
        accessLevel,
        accessLoading,
        router,
        router.pathname,
        router.asPath,
        router.query?.redirectTo,
    ]);

    if (loading || accessLoading || !authorized) {
        return null;
    }

    return children;
}
